<template>
  <div class="container">
    <content-template>
      <template slot="left">理事長網誌</template>
      <template slot="right">
        <li>
          <router-link to="/announced" class="router-style">新年文告</router-link>
        </li>
        <li><a class="is-check" style="color: #5571EC;"  @click="getEcononmic">我的社會經濟觀</a></li>
      </template>
      <template slot="content">
        <div v-html="pageContent"></div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      pageContent: ''
    }
  },
  methods: {
    getPage: function (page) {
      var that = this
      var url = this.$url + 'portal/pages/' + page
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.code === 1) {
            that.pageContent = response.data.data.post_content
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 关于本站
    getEcononmic: function () {
      this.getPage(3)
    }
  },
  created () {
    this.getEcononmic()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/mediaCenter/myEconomicOutlook.vue